<template>
  <div class="distribution">
    <el-row>
      <el-col :span="isHearderMenu?5:6" class="al">
        <div style="float:left;padding-top: 3px;">
          <el-image style="width: 40px; height: 40px;" :src="Config.logo" fit="contain"></el-image>
        </div>
        <div class="title">{{Config.title}}</div>
      </el-col>
      <el-col v-if="isHearderMenu" :span="13">
        <div class="sysTabbar">
          <div class="sysTabbarList">
            <div class="sysTabbarItem" v-for="(item,index) in TemplateMenuShow.slice(0,maxCount)" :key="index" v-ripple
              @click="menuClick(item)">
              <div class="iconCircle">
                <el-tooltip :content="item.NAME" placement="bottom" effect="light">
                  <i class="iconfont" :class="item.ICON" :style="{'font-size': item.NAME=='工作轨迹'?'22px':'20px'}"></i>
                </el-tooltip>
              </div>
              <div :class="{ angle: menuId==item.ID}"></div>
            </div>
            <el-popover
              v-if="TemplateMenuSetting.length>0"
              placement="bottom"
              class="popover"
              title="菜单展示设置（双击切换）最多显示七个"
              width="300"
              trigger="click"
            >
              <!--<el-row v-for="(item,index) in TemplateMenuSetting" @dblclick.native="menuClick(item)" class="tagrow" :style="{'border-bottom': TemplateMenu.length==(index+1)?'':'1px solid #eaecf2'}" style="padding: 8px 10px 8px 10px;font-size: 16px;font-weight: unset;" :key="index">
                <el-col :span="16">{{item.NAME}}</el-col>
                <el-col :span="8" style="text-align: right;">
                  <el-switch
                    @change="ShowHide(item)"
                    v-model="item.VISIBLE">
                  </el-switch>
                </el-col>
              </el-row>-->
              <el-row
                v-for="(item,index) in TemplateMenu"
                @mouseenter.native="selectIndex=index"
                @dblclick.native="menuClick(item)"
                class="tagrow"
                :style="{'border-bottom': TemplateMenu.length==(index+1)?'':'1px solid #eaecf2'}"
                style="padding: 8px 10px 8px 10px;font-size: 16px;font-weight: unset;"
                :key="index"
              >
                <el-col :span="selectIndex==index?10:16">{{item.NAME}}</el-col>
                <el-col :span="6" style="text-align: right;" v-if="selectIndex==index">
                  <el-link
                    :type="item.ISDEFAULT?'primary':'warning'"
                    @click="setDefault(item);"
                  >{{item.ISDEFAULT?"取消默认":"设为默认"}}</el-link>
                </el-col>
                <el-col :span="8" style="text-align: right;">
                  <el-switch
                    @change="ShowHide(item)"
                    :disabled="item.NAME=='首页'"
                    v-model="item.VISIBLE"
                  ></el-switch>
                </el-col>
              </el-row>
              <div
                slot="reference"
                class="sysTabbarItem"
                v-ripple
                style="width:55px;"
                :class="{ sysTabSelected: false}"
              >
                更多
                <i class="el-icon-arrow-down"></i>
              </div>
            </el-popover>

            <!--<div
              class="sysTabbarItem"
              :class="{ sysTabSelected: true}"
            ><i class="iconfont icon-zhuye"></i>首页</div>
             <div
              class="sysTabbarItem"
              :class="{ sysTabSelected: false}"
            >团队任务</div>-->
          </div>
        </div>
      </el-col>
      <el-col :span="isHearderMenu?6:6" class="lineh">
        <el-popover
          placement="bottom"
          trigger="manual"
          v-model="loginVisible"
          >
        <span class="acclogin" slot="reference">
          <span @click="acclogIn">
            <span class="peopleImg">
              <el-image style="width: 32px; height: 32px;" :src="peopleUrl" fit="contain"></el-image>
            </span>
            <span class="people">{{realName}}</span>
          </span>
        </span>
        <!-- 登录模块 -->
          <login-modu 
          ref="loginModu" 
          :loginVisible="loginVisible"
          @closeDialog="closeDialog"
          @closelogm="closelogm"
          class="loginM"
          ></login-modu>
        </el-popover>
        <el-divider v-if="isViewType" direction="vertical"></el-divider>
        <el-dropdown v-if="isViewType" @command="onViewTypeChange">
          <el-button size="mini" type="primary">
            {{ViewTypeName}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item,index) in ViewTypeState"
              :key="index"
              :command="item.value"
            >{{item.name}}</el-dropdown-item>

            <!-- <el-dropdown-item command="list">列表视图</el-dropdown-item>
            <el-dropdown-item command="card">卡片视图</el-dropdown-item>
            <el-dropdown-item command="stat">统计视图</el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import loginModu from "@/views/task/common/login/loginModu.vue";

import configApi from "@/api/modules/basicData/config";
import {
  SetDefaultTemplate,
} from "@/api/modules/basicData/task";
import {
  UpdateTemplateUserSetting
} from "@/api/modules/basicData/task";
import { mapState } from "vuex";
export default {
  components:{
    loginModu
  },
  data() {
    return {
      maxCount:7,
      loginVisible:false, //登录框默认不显示
      selectIndex:-1,
      menuId:'',
      imgUrl: require("@/assets/0/logo.jpg"),
      peopleUrl: require("@/assets/0/people.png"),
      Config: {}
    };
  },
  props: {
    isViewType: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
      realName: state => state.task.realName,
      ViewTypeState: state => state.task.ViewTypeState,
      ViewTypeName: state => state.task.ViewTypeName,
      TemplateMenu: state => state.task.TemplateMenu,
      userId: state => state.task.userId,
    }),
    isHearderMenu(){
      return this.$store.state.task.TemplateMenu.length>0
    },
    TemplateMenuShow(){
      return this.$store.state.task.TemplateMenu.filter(item=>item.VISIBLE==true);
    },
    TemplateMenuSetting(){
      return this.$store.state.task.TemplateMenu;
    }
  },
  methods: {
    closelogm(val){
      console.log(val);
      
      this.loginVisible=val;
    },
    closeDialog(val){
      this.loginVisible=val;
    },
    acclogIn(){
      // this.loginVisible=true;
      this.loginVisible=!this.loginVisible;
      console.log("登录模块",this.loginVisible);

    },
    menuClick(data){
      if(data){
        this.menuId=data.ID;
        this.$emit('getComponent',data);
      }
    },
    ShowHide(row){
      console.log('ShowHide',row);
      if(this.TemplateMenuShow.length>this.maxCount){
        this.$message.info('最多显示'+this.maxCount+'个')
        this.TemplateMenuShow.forEach(item=>{
          if(row.ID===item.ID){
            item.VISIBLE=false;
          }
        });
      }else{
        UpdateTemplateUserSetting(row.ID,this.userId,row.VISIBLE).then(res=>{

        })
      }
    },
    onViewTypeChange(type) {
      let viewType = this.ViewTypeState.filter(item => item.value === type);
      if (viewType.length > 0) {
        this.$store.state.task.ViewTypeName = viewType[0].name;
        this.$store.state.task.viewType = type;
      }
    },
    setDefault(row){
      SetDefaultTemplate(row.ID, this.userId,row.CATEGORY,1,row.ISDEFAULT).then(res => {
        if (res == 1) {
          this.TemplateMenu.forEach(item=>{
            if(row.ID==item.ID && !row.ISDEFAULT)
            item.ISDEFAULT=true;
            else
            item.ISDEFAULT=false;
          })
          this.$message({
            type: "success",
            message: "设置成功!"
          });
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
       let defaultInfo = this.TemplateMenu.find(item=>item.ISDEFAULT==true)
       if(defaultInfo) this.menuClick(defaultInfo)
       else this.menuClick(this.TemplateMenu.filter(item=>item.NAME=='首页')[0])

        configApi
          .GetSite(0)
          .then(result => {
            console.log(result);
            this.Config = JSON.parse(result);
            this.Config.logo=this.Backstage_ROOT+this.Config.logo;
          })
          .catch(err => {
            this.$message.error(err);
          });
      }, 1000);
    });
  }
};
</script>
<style lang="scss" scoped>
  .iconRight {
    height: 27px;
    width: 22px;
    // background-color: #57C2FB;
    margin-top: 10px;
    line-height: 27px;
    border-radius: 4px;
    text-align: center;
  }

  .iconCircle {
    height: 39px;
    width: 39px;
    border-radius: 50%;
    margin-top: 4px;
    line-height: 39px;
  }

  .iconCircle:hover {
    // background-color: #1590D1;
  }

  .poplogin {
    padding: 0px !important;
    height: 200px;
  }

  .acclogin {
    cursor: pointer;
  }

  .loginM {
    width: 100%;
    height: 105px;
  }

  .title {
    margin-left: 5px;
    margin-top: 5px;
    font-size: 24px;
    letter-spacing: 0.9px;
    float: left;
    color: white;
  }

  .distribution {
    background-color: rgb(25, 172, 249);
    color: #ffffff;
    padding: 0 20px;
  }

  .people {
    font-size: 18px;
    letter-spacing: 0.6px;
  }

  .peopleImg {
    background-color: rgb(25, 172, 249);
  }

  .lineh {
    text-align: right;
    margin-top: -4px;
    background-color: rgb(25, 172, 249);
  }
</style>

<style scoped>
  .distribution>>>.el-divider--vertical {
    margin-bottom: 2px;
  }

  .peopleImg>>>.el-image {
    top: 10px;
  }

  .lineh>>>.el-button--primary {
    background-color: rgb(25, 172, 249);
    border-color: rgb(25, 172, 249);
  }

  .lineh>>>.el-button--mini {
    font-size: 16px;
  }
</style>
<style lang="less" scoped>
  .el-popover {
    padding: 0px !important;
    min-width: 100px !important;
  }

  // .sysTabbar:hover {
  //   .iconRight {
  //     opacity: 1;
  //     transition: all 0.5s;
  //   }
  // }

  .sysTabbar {
    width: 100%;
    height: 47px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .sysTabbarList {
      display: flex;

      .sysTabbarItem {
        cursor: pointer;
        width: 65px;
        text-align: center;
        box-sizing: border-box;
        position: relative;
        padding-left: 13px;
        margin-left: 2px;
        line-height: 44px;
        color: #ffffff;
        overflow: hidden;
        .angle{
          height: 15px;
          width: 15px;
          background-color: #FFFFFF;
          position: absolute;
          left: 25px;
          border-radius: 1px;
          transform:rotate(45deg);
          -ms-transform:rotate(45deg); 	/* IE 9 */
          -moz-transform:rotate(45deg); 	/* Firefox */
          -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
          -o-transform:rotate(45deg); 	/* Opera */
        }

        i {
          margin-left: 4px;
        }

        .iconfont {
          margin-right: 3px;
        }
      }

      .sysTabSelected {

      }
    }

    .sysTabbarEdit {
      cursor: pointer;
      width: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
